import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./components/Pages/HomePage";
import Main from "./components/Appbar/Main";
import ServicesPage from "./components/Pages/ServicesPage";
import AboutPage from "./components/Pages/AboutPage";
import Contactus from "./components/Contact/Contactus";
import ScrollToTop from "./components/ScrolltoTop/ScrolltoTop";
import PortfolioPage from "./components/Pages/Portfolio";
import Appointment from "./components/Pages/Appointment";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main activePage={<HomePage />} />} />
        <Route
          path="/services"
          element={<Main activePage={<ServicesPage />} />}
        />
        <Route path="/about" element={<Main activePage={<AboutPage />} />} />
        <Route path="/Contact" element={<Main activePage={<Contactus />} />} />
        <Route
          path="/portfolio"
          element={<Main activePage={<PortfolioPage />} />}
        />
        <Route
          path="/booking"
          element={<Main activePage={<Appointment />} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
